import * as React from 'react';

function SvgRingVolume(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path
				d='M18.6 17.22c.66.37 1.28.79 1.87 1.27l1.07-1.07c-.91-.75-1.9-1.38-2.94-1.9v1.7zM3.53 18.5c.58-.47 1.21-.89 1.87-1.27v-1.71a15.13 15.13 0 00-2.95 1.9l1.08 1.08z'
				opacity={0.3}
			/>
			<path d='M12 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 00-.29-.7A16.971 16.971 0 0012 12zm-6.6 5.23c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zM16.19 8.4l1.41 1.41s3.45-3.52 3.56-3.55l-1.41-1.41-3.56 3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' />
		</svg>
	);
}

export default SvgRingVolume;
